// extracted by mini-css-extract-plugin
module.exports = {"widgetList":"WidgetList_widgetList__1rghg"};